import React from 'react';

interface UseIntersectionObserverOptions {
  threshold?: number;
  rootMargin?: string;
}

const useIntersectionObserver = (
  elementRef: React.RefObject<Element | null>,
  options?: UseIntersectionObserverOptions
): boolean => {
  const [visible, setVisible] = React.useState<boolean>(false);

  React.useEffect(() => {
    const { current } = elementRef || {};

    if (!current || !window.IntersectionObserver) return;

    const observer = new window.IntersectionObserver((entries) => {
      const [entry] = entries;

      setVisible(entry.isIntersecting);
    }, options);

    observer.observe(current);

    return () => {
      observer.unobserve(current);
      observer.disconnect();
    };
  }, [elementRef, options]);

  return visible;
};

export default useIntersectionObserver;
